export default "__VITE_ASSET__DZoBT4sm__"